const BackgroundImage = () => {
  return {
    template: `
      <div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)) 0% 0% / cover no-repeat, url(//images.ctfassets.net/jkgruwrd4gsu/4PFgcnijL8ibGrW4afFqzl/1167f51af5fe7c768c789e69c5edd19a/Table_Number_v2.png); background-size: cover;">
        <story/>
      </div>
    `,
  };
};

export default BackgroundImage;
